import _filter from 'lodash/filter';
import _map from 'lodash/map';

const isDisabled = obj =>
  typeof obj === 'object'
    ? _filter(
        _map(Object.keys(obj), i => obj[i] === 0),
        i => i
      ).length > 0
    : null;

const removeSubpathFromUrl = (url, indexTrim = 0) =>
  url
    .split('/')
    .slice(0, url.split('/').length - (indexTrim + 1))
    .join('/');

export { isDisabled, removeSubpathFromUrl };
